// removed by extract-text-webpack-plugin
module.exports = {"coverCropper":"_29kfbNH5jObOuy5cGHguIW","cover":"_1VB9NhJPvzywuJAn0wVJNV","coverActions":"_1TOeF-wvQObh6fY6S0zE4b","coverButtons":"_2eRrLevrKo-mouTaDvmtbG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Cover/ProjectCover.scss
// module id = 1297
// module chunks = 1